import { createIndirectAPIActionGenerator, APIRequest } from 'utils/apidata';

export type BulkToggleCommentPostingRequest = APIRequest<null> & {
  isEnabled: 0 | 1;
  organizationUUID: string;
};

export function getCommentPostingKey(
  request: BulkToggleCommentPostingRequest
): string {
  return `${request.organizationUUID}`;
}

export const generators = {
  toggle: createIndirectAPIActionGenerator<
    BulkToggleCommentPostingRequest,
    null
  >({
    prefix: 'ORGANIZATIONS/COMMENT_POSTING/TOGGLE',
    getKey: getCommentPostingKey,
  }),
};
